import * as React from 'react';
import PropType from 'prop-types';
import { Transition } from 'react-spring/renderprops';

import AudioPlayerComponentActiveMedia from '../components/ComponentActiveMedia';
import AudioPlayerComponentOnAir from '../components/ComponentOnAir';

import Icon from '../../../00_atoms/icon/Icon';

/*
 * Main View Component
 * --------------------
 */

class AudioPlayerViewMain extends React.Component {
  constructor(props) {
    super(props);
    this.handleCollapseExpandClick = this.handleCollapseExpandClick.bind(this);
  }

  handleCollapseExpandClick(event) {
    const target = event.currentTarget;
    const newState = target.dataset.newState;
    this.props.setExpandState(newState);
    window.ArnAnalytics.customEvent({
      category: 'Audio Player',
      action: 'Player resize button pressed',
      label: newState,
    });
  }

  render() {
    const isExpanded = this.props.isExpanded;
    const dataActiveShow = this.props.dataActiveShow;
    const dataSong = this.props.dataSong;
    const dataPodcast = this.props.dataPodcast;
    const audioState = this.props.audioState;
    const logo = this.props.logo;
    const isMuted = this.props.isMuted;
    const isPaused = this.props.isPaused;

    // Column A - iHR Callout widget
    const colAClassesExpanded = `col-lg-4 u-d-none u-d-lg-block u-d-xl-block`;
    const colAClassesMinified = `col col-0`;
    const colAContentExpanded = (
      <div className={`po-audio-player__ihr po-audio-player__ihr--is-expanded`}>
        <img
          src={logo}
          className={`po-audio-player__ihr__logo`}
          alt={`Powered By I Heart Radio`}
        />
      </div>
    );
    const colAContentMinified = (
      <div className={`po-audio-player__ihr po-audio-player__ihr--is-minified`}>
        <div>
          <span className={`po-audio-player__ihr__text`}>POWERED BY</span>
        </div>
        <div>
          <img
            src={`/wp-content/themes/arn/assets/img/ihr_logo_white.png`}
            className={`po-audio-player__ihr__logo`}
            alt={`Powered By I Heart Radio`}
          />
        </div>
      </div>
    );

    // Column B - Main Media Unit
    const colBClassesExpanded = `col-sm-12 col-lg-4`;
    const colBClassesMinified = `col col-sm-12 col-lg-7`;
    const colBContentExpanded = (
      <AudioPlayerComponentActiveMedia
        audioState={audioState}
        dataActiveShow={dataActiveShow}
        dataPodcast={dataPodcast}
        handlePlayPause={this.props.handlePlayPause}
        handleSkipForward={this.props.handleSkipForward}
        handleSkipBackward={this.props.handleSkipBackward}
        handleProgressBarInput={this.props.handleProgressBarInput}
        isMuted={isMuted}
        isPaused={isPaused}
        isExpanded
      />
    );

    const colBContentMinified = (
      <AudioPlayerComponentActiveMedia
        audioState={audioState}
        dataActiveShow={dataActiveShow}
        dataPodcast={dataPodcast}
        handlePlayPause={this.props.handlePlayPause}
        handleSkipForward={this.props.handleSkipForward}
        handleSkipBackward={this.props.handleSkipBackward}
        handleProgressBarInput={this.props.handleProgressBarInput}
        isMuted={isMuted}
        isExpanded={false}
        isPaused={isPaused}
      />
    );

    // Column C - Now Playing Unit
    const colCClassesExpanded = `col-sm-12 col-lg-4`;
    const colCClassesMinified = `col col-lg-5 u-d-none u-d-lg-block u-d-xl-block`;
    const colCContentExpanded = (
      <AudioPlayerComponentOnAir
        audioState={audioState}
        dataActiveShow={dataActiveShow}
        dataSong={dataSong}
        logo={logo}
        isExpanded
      />
    );
    const colCContentMinified = (
      <AudioPlayerComponentOnAir
        audioState={audioState}
        dataActiveShow={dataActiveShow}
        dataSong={dataSong}
        logo={logo}
        isExpanded={false}
      />
    );

    const expandedClass = isExpanded
      ? `po-audio-player__view-main--is-expanded`
      : `po-audio-player__view-main--is-minified`;

    const stateChangeButtonActionExpanded = 'minified';
    const stateChangeButtonActionMinified = 'expanded';
    const stateChangeButtonValueExpanded = (
      <Icon
        iconName={`Minimise`}
        xLink={`/wp-content/themes/arn/assets/icons/sprite.svg`}
        iconTitle={`Minimise player`}
      />
    );
    const stateChangeButtonValueMinified = (
      <Icon
        iconName={`Expand`}
        xLink={`/wp-content/themes/arn/assets/icons/sprite.svg`}
        iconTitle={`Expand player`}
      />
    );

    const stylesEnter = {
      position: 'absolute',
      left: 0,
      opacity: 1,
      width: '100%',
      // transform: 'translate3d(0%,0,0)',
      height: '100%',
      paddingBottom: '4px',
      paddingTop: '4px',
    };
    const stylesLeave = {
      position: 'absolute',
      // left: -800,
      opacity: 0,
      width: '100%',
      // transform: 'translate3d(-50%,0,0)',
      height: '100%',
      paddingBottom: '4px',
      paddingTop: '4px',
    };
    const stylesStart = {
      opacity: 0,
      width: '100%',
      position: 'absolute',
      // left: 800,
      // transform: 'translate3d(50%,0,0)',
      height: '100%',
      paddingBottom: '4px',
      paddingTop: '4px',
    };

    const backgroundStyle = {
      backgroundImage: `url(${this.props.backgroundOne})`,
    };

    const backgroundTwoStyle = {
      display: 'none',
    };
    if (this.props.backgroundTwo) {
      backgroundTwoStyle.backgroundImage = `url(${this.props.backgroundTwo})`;
      backgroundTwoStyle.display = 'inline-block';
    }

    const splitterStyle = {};

    if (this.props.backgroundSplit === 'no-split') {
      splitterStyle.display = 'none';
    }

    const views = [
      style => (
        <div style={style}>
          <div className={`po-audio-player__backgrounder`}>
            <div
              className={`po-audio-player__backgrounder__fancy--texture`}
              style={backgroundStyle}
            />
            <div
              className={`po-audio-player__backgrounder__normal`}
              style={splitterStyle}
            />
          </div>
          <div className={`po-audio-player__container-row container`}>
            <div className={`po-audio-player__view-main row ${expandedClass}`}>
              <div className={colAClassesMinified}>{colAContentMinified}</div>
              <div className={colBClassesMinified}>{colBContentMinified}</div>
              <div className={colCClassesMinified}>{colCContentMinified}</div>
              <div
                className={`po-audio-player__collapse-expand-button`}
                data-new-state={stateChangeButtonActionMinified}
                onClick={this.handleCollapseExpandClick}
              >
                {stateChangeButtonValueMinified}
              </div>
            </div>
          </div>
        </div>
      ),
      style => (
        <div style={style} className={`po-audio-player__resizing-container`}>
          <div className={`po-audio-player__backgrounder`}>
            <div
              className={`po-audio-player__backgrounder__fancy--texture`}
              style={backgroundStyle}
            />
            <div
              className={`po-audio-player__backgrounder__accent`}
              style={backgroundTwoStyle}
            />
            <div
              className={`po-audio-player__backgrounder__fancy--splitter`}
              style={splitterStyle}
            />
          </div>
          <div className={`po-audio-player__container-row container`}>
            <div className={`po-audio-player__view-main row ${expandedClass}`}>
              <div className={colAClassesExpanded}>{colAContentExpanded}</div>
              <div className={colBClassesExpanded}>{colBContentExpanded}</div>
              <div className={colCClassesExpanded}>{colCContentExpanded}</div>
              <div
                className={`po-audio-player__collapse-expand-button`}
                data-new-state={stateChangeButtonActionExpanded}
                onClick={this.handleCollapseExpandClick}
              >
                {stateChangeButtonValueExpanded}
              </div>
            </div>
          </div>
        </div>
      ),
    ];

    const viewNum = isExpanded ? 1 : 0;

    return (
      <Transition
        unique
        delay={75}
        config={{ tension: 500, friction: 29, precision: 0.875 }}
        from={stylesStart}
        enter={stylesEnter}
        leave={stylesLeave}
        items={viewNum}
      >
        {index => views[index]}
      </Transition>
    );
  }
}

AudioPlayerViewMain.propTypes = {
  isExpanded: PropType.bool.isRequired,
  dataActiveShow: PropType.object.isRequired,
  dataSong: PropType.object.isRequired,
  dataPodcast: PropType.object.isRequired,
  audioState: PropType.string.isRequired,
  setExpandState: PropType.func.isRequired,
  handlePlayPause: PropType.func.isRequired,
  handleSkipForward: PropType.func.isRequired,
  handleSkipBackward: PropType.func.isRequired,
  handleProgressBarInput: PropType.func.isRequired,
  isMuted: PropType.bool,
  isPaused: PropType.bool,
};

export default AudioPlayerViewMain;
